import "../styles/MessageBubble.css";
import RichText from "./RichText";
import TypingRichText from "./TypingRichText";

export default function MessageBubble({
  role,
  text,
  parts,
  meta,
  typing = false,
  typingText = "",
  onAction,
  animate = false,
  onTypingDone,
}) {
  const isError = meta?.type === "error";
  const msgAction = meta?.action || null;

  if (typing) {
  return (
    <div className={`bubble bubble--${role}`}>
      {typingText ? (
        <div className="bubbleThinkingText">
          {typingText}
        </div>
      ) : (
        <span className="bubbleTyping" aria-label="typing">
          <i />
          <i />
          <i />
        </span>
      )}
    </div>
  );
}

  const shouldAnimateText =
    role === "assistant" &&
    animate &&
    !isError &&
    !msgAction &&
    (text || (Array.isArray(parts) && parts.length > 0));

  return (
    <div className={`bubble bubble--${role} ${isError ? "bubble--error" : ""}`}>
      {shouldAnimateText ? (
        <TypingRichText
          className="bubbleText"
          text={text}
          parts={parts}
          speed={14}
          enabled={true}
          onDone={onTypingDone}
        />
      ) : (
        <RichText className="bubbleText" text={text} parts={parts} />
      )}

      {msgAction?.type ? (
        <button
          type="button"
          className="bubbleActionBtn"
          onClick={() => onAction?.(msgAction)}
        >
          {msgAction.label || "Відкрити"}
        </button>
      ) : null}
    </div>
  );
}